module.exports = __webpack_public_path__ + "img/3.0c3ec0bf.png";